import config from "@config"
import qrImg from "@images/qr.png"
import {
  animated,
  config as springConfig,
  useSpring,
  useTrail,
} from "@react-spring/web"
import { platformCheck, postAppMsg, postMsg } from "@src/utils/request"
import classnames from "@utils/classnames"
import React from "react"
import Clickable from "../clickable"
import Icon from "../icon"
import * as styles from "./page.module.scss"
import shareImg from "@images/share.png"
import { useContext } from "react"
import AppContext from "@src/context/appContext"
import { trackShare } from "@src/utils/sensors"

const { pageDelay, pageTotalDuration } = config
const scrollTipDelay = (duration) => pageDelay + duration + 2000

const statusMapper = {
  prev: -1,
  active: 0,
  next: 1,
}

const createPage =
  (
    Page,
    baseProps = {},
    { totalDuration = pageTotalDuration, hideQr = false, showShare } = {}
  ) =>
  (props) => {
    const { isWXBrowser } = useContext(AppContext)
    const { active, status, pageName, data, isLastPage } = props
    const offset = statusMapper[status]
    const { offset: offsetAnimation } = useSpring({
      config: springConfig.slow,
      delay: pageDelay,
      from: { offset: statusMapper.next },
      to: { offset },
    })
    const tipSpring = useTrail(2, {
      opacity: active ? 1 : 0,
      delay: active ? scrollTipDelay(totalDuration) : 0,
      from: { opacity: 0 },
    })

    return (
      <animated.div
        {...baseProps}
        style={{
          transform: offsetAnimation.to(
            (o) => `translate3d(0px, ${(o * 100).toFixed(2)}%, 0px)`
          ),
        }}
        className={classnames(
          styles.page,
          {
            [styles.active]: active,
            [`page-${pageName}`]: pageName,
          },
          baseProps.className
        )}
      >
        <div className={classnames("o_pageInner", styles.pageInner)}>
          <Page {...props} offset={offset} />
        </div>
        {showShare && (
          <Clickable
            className={styles.share}
            onClick={() => {
              trackShare()
              platformCheck(
                () => {
                  if (window.getShareData) {
                    const data = window.getShareData()
                    postAppMsg("share", {
                      ...data,
                      image: data.imgUrl,
                    })
                  }
                },
                () => {
                  if (isWXBrowser) {
                    alert("请点击 ... 以转发分享")
                  } else {
                    alert("请使用 App 访问以分享")
                  }
                }
              )
            }}
          >
            <animated.div style={tipSpring[0]}>
              <img src={shareImg} alt="share" />
            </animated.div>
          </Clickable>
        )}
        {!showShare && !hideQr && (
          <animated.div
            className={classnames("o_qr", styles.qr)}
            style={tipSpring[0]}
          >
            <img src={qrImg} alt="qr" />
          </animated.div>
        )}
        {data?.loaded && !isLastPage && (
          <animated.div
            className={classnames("o_scrollTip", styles.scrollTip)}
            style={tipSpring[1]}
          >
            <Icon icon="angle-down" />
          </animated.div>
        )}
      </animated.div>
    )
  }

export default createPage
